/** Testo predefinito quando il documento è in regime forfettario (assenza IVA). Usato per offerte e fatture. */
export const DEFAULT_NO_VAT_FORFETTARIO_CLAUSE =
  'Operazione non soggetta a IVA ai sensi dell\'art. 1, commi 54-89, Legge n. 190/2014 e successive modificazioni (regime forfettario).';

export function resolveNoVatClauseText(custom: string | null | undefined): string {
  const t = (custom || '').trim();
  return t || DEFAULT_NO_VAT_FORFETTARIO_CLAUSE;
}

/** Soglia (€) sopra la quale, in regime forfettario, è dovuta marca da bollo da €2. */
export const MARCA_DA_BOLLO_THRESHOLD = 77.47;
export const MARCA_DA_BOLLO_AMOUNT = 2.0;

/** Calcola marca da bollo (auto): €2 se forfettario e imponibile > soglia, altrimenti 0. */
export function computeMarcaDaBollo(taxableAmount: number, noVatForfettario: boolean): number {
  if (!noVatForfettario) return 0;
  return taxableAmount > MARCA_DA_BOLLO_THRESHOLD ? MARCA_DA_BOLLO_AMOUNT : 0;
}
